
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Box, Card, CardHeader, CardBody, Heading, Text, Spinner, VStack } from '@chakra-ui/react'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { TranslationForm } from '@/components/forms/TranslationForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function EditTranslationPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const translationId = id ? Number(id) : undefined
  const [isValidating, setIsValidating] = useState(true)

  useEffect(() => {
    if (!translationId || Number.isNaN(translationId)) {
      navigate('/system-settings/language', { replace: true })
    } else {
      setIsValidating(false)
    }
  }, [translationId, navigate])

  const handleSuccess = () => {
    navigate('/system-settings/language')
  }

  const handleCancel = () => {
    navigate('/system-settings/language')
  }

  if (isValidating || !translationId) {
    return (
      <AdminLayout>
        <Box p={4}>
          <Card>
            <CardBody>
              <VStack spacing={4} py={8}>
                <Spinner size="xl" color="blue.500" />
                <Text>Loading...</Text>
              </VStack>
            </CardBody>
          </Card>
        </Box>
      </AdminLayout>
    )
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Edit Translation</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Update translation information
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <TranslationForm translationId={translationId} onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}

